import React from 'react'
import LoginFrame from '../shared/LoginFrame'
import AddedPasskeyIcon from '../icons/AddedPasskeyIcon'
import {
  InjectedFrameProps,
  withFrameProps,
} from '../../context/withFrameProps'
import { eventHandler } from '../../types.d'
import { preventDefault } from '../../helpers'
import { useAppDispatch } from '../../store/store'
import { completeAuthFlow } from '../../store'

type PureCreatePasskeySuccessProps = {
  onContinue: eventHandler
} & Exclude<InjectedFrameProps, 'hasPreviousStep'>

export const PureCreatePasskeySuccess = ({
  onContinue,
  loading,
  error,
  logoUrl = null,
}: PureCreatePasskeySuccessProps) => (
  <LoginFrame
    title={null}
    recaptchaSiteKey={null}
    {...{ loading, error, logoUrl }}
  >
    <div className="space-y-4">
      <div className="flex items-center justify-center">
        <AddedPasskeyIcon />
      </div>
      <p className="text-center font-medium text-lg">Passkey created</p>

      <p className="!mt-3 !mb-0 text-center">
        You can now sign in using a passkey, in addition to your usual methods.
      </p>
    </div>
    <button
      onClick={preventDefault(onContinue)}
      type="submit"
      tabIndex={1}
      className="w-full text-white bg-slate-600 hover:bg-slate-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
    >
      Continue
    </button>
  </LoginFrame>
)

const BoundCreatePasskeySuccess = withFrameProps(PureCreatePasskeySuccess, {})

export const CreatePasskeySuccess = () => {
  const dispatch = useAppDispatch()

  const handleContinue = (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(completeAuthFlow({ action: 'created' }))
  }

  return <BoundCreatePasskeySuccess onContinue={handleContinue} />
}

export default CreatePasskeySuccess
